module.exports = __webpack_public_path__ + "static/media/Engpic4@2x.8e1b0879.png";